export default "__VITE_ASSET__CyxXUO1u__"